export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Inserisci qui il tuo testo",
      conversationalPlaceholder: "Inserisci qui la tua risposta",
      conversationClosed: "Conversazione chiusa.",
      conversationalDisclaimer: "Le domande di follow-up saranno generate dall'IA in base alle tue risposte."
    },
    openText: {
      openEndPlaceholder: "Inserisci qui il tuo testo"
    },
    multiText: {
      fieldPlaceholder: 'Risposta {number}',
      instruction: 'Scrivi almeno {count} risposta qui sotto, una per casella di testo | Scrivi almeno {count} risposte qui sotto, una per casella di testo',
      instructionWithoutMinimum: 'Scrivi le tue risposte qui sotto, una per casella di testo',
      minimumEntries: 'Inserisci almeno {count} risposta per continuare. | Inserisci almeno {count} risposte per continuare.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Marca {number}',
        minimumEntries: 'Inserisci almeno {count} marca per continuare. | Inserisci almeno {count} marche per continuare.'
      }
    },
    multiselect: {
      caption: "Seleziona tutte le opzioni pertinenti"
    },
    rankOrder: {
      enterRankOrder: "Inserisci l'ordine di preferenza",
      placeholder: "Trascina qui le tue scelte per ordinarle"
    },
    openNumeric: {
      label: "Campo numerico aperto"
    },
    complete: {
      message: "Grazie per aver completato il sondaggio."
    },
    openVideo: {
      warning: "Per favore, registra un video prima di procedere.",
      uploadStatusUploading: "Attendi mentre elaboriamo il tuo video prima di continuare...",
      uploadStatusSuccess: "Caricamento riuscito, puoi continuare.",
      uploadStatusError: "Caricamento non completato, riprova."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Inserisci un\'indirizzo email valido',
      text_invalid_phone: 'Inserisci un numero di telefono valido',
      text_invalid_us_zip: 'Inserisci un codice postale ZIP valido (USA)',
      text_invalid_ca_postal: 'Inserisci un codice postale canadese valido',
      text_invalid_uk_postal: 'Inserisci un codice postale del Regno Unito valido',
      text_invalid_custom: 'Inserisci un valore valido per {fieldName}',
      text_min_chars: 'Inserisci almeno {min} caratteri',
      text_max_chars: 'Inserisci al massimo {max} caratteri',
      text_alpha_not_allowed: 'Sono consentiti solo caratteri numerici',
      text_numeric_not_allowed: 'Sono consentiti solo caratteri alfabetici'
    },
    external: {
      invalid: 'La risposta a questa domanda non è valida.',
      required: 'È necessario rispondere a questa domanda.',
      singlechoice_required: 'Seleziona un\'opzione prima di procedere.',
      numeric_required: 'Seleziona una valutazione prima di procedere.',
      text_required: 'Inserisci una risposta prima di procedere.',
      bigtext_required: 'Inserisci una risposta prima di procedere.',
      singlechoiceother_incomplete: 'Inserisci una risposta prima di procedere.',
      multiselectother_incomplete: 'Inserisci una risposta prima di procedere.',
      numeric_invalid: 'Inserisci un numero valido prima di procedere.',
      radiogrid_required: 'Seleziona un\'opzione per ogni riga prima di procedere.',
      incomplete: 'Rispondi alla domanda prima di continuare.',
      multiselect_min: 'Seleziona almeno {value} opzioni prima di procedere.',
      multiselect_max: 'Non selezionare più di {value} opzioni prima di procedere.',
      multiselectother_min: 'Seleziona almeno {value} opzioni prima di procedere.',
      multiselectother_max: 'Non selezionare più di {value} opzioni prima di procedere.',
      multiselectgrid_min: 'Seleziona almeno {value} opzioni per ogni riga prima di procedere.',
      multiselectgrid_max: 'Non selezionare più di {value} opzioni per ogni riga prima di procedere.',
      rankorder_min: 'Classifica almeno {value} elementi prima di procedere.',
      rankorder_max: 'Non classificare più di {value} elementi prima di procedere.'
    }
  }
}
